svatky = [
  '1-1'
  '1-5'
  '8-5'
  '5-7'
  '6-7'
  '28-9'
  '28-10'
  '17-11'
  '24-12'
  '25-12'
  '26-12'
  '27-12'
  '28-12'
  '29-12'
  '30-12'
  '31-12'
]

dny = [
  'dnes'
  'zítra'
  'pozítří'
]

denVTydnu = [
  'v neděli'
  'v pondělí'
  'v úterý'
  've středu'
  've čtvrtek'
  'v pátek'
  'v sobotu'
]

addBusinessDays = (d, n) ->
  d = new Date(d.getTime())
  day = d.getDay()
  plusDni = (if day % 6 then n else 0) + (if day == 6 then 2 else + !day) + Math.floor((n - 1 + (day % 6 or 1)) / 5) * 2
  dni = plusDni
  d.setDate d.getDate() + plusDni
  n = 1
  while svatky.includes(d.getDate() + '-' + (d.getMonth() + 1))
    day = d.getDay()
    plusDni = (if day % 6 then n else 0) + (if day == 6 then 2 else + !day) + Math.floor((n - 1 + (day % 6 or 1)) / 5) * 2
    dni = dni + plusDni
    d.setDate d.getDate() + plusDni
  d

getEaster = (year) ->
  f = Math.floor
  G = year % 19
  C = f(year / 100)
  H = (C - f(C / 4) - f((8 * C + 13) / 25) + 19 * G + 15) % 30
  I = H - (f(H / 28) * (1 - (f(29 / (H + 1)) * f((21 - G) / 11))))
  J = (year + f(year / 4) + I + 2 - C + f(C / 4)) % 7
  L = I - J
  month = 3 + f((L + 40) / 44)
  day = L + 28 - (31 * f(month / 4))
  [
    month
    day
  ]

changeTimezone = (date, ianatz) ->
  invdate = new Date(date.toLocaleString('en-US', timeZone: ianatz))
  diff = date.getTime() - invdate.getTime()
  new Date(date.getTime() + diff)


renderClock = (element, date) ->
  $(element).countdown(date, (event) ->
    totalHours = event.offset.totalDays * 24 + event.offset.hours
    $(this).html event.strftime(totalHours + ':%M:%S')
    return
  ).on('finish.countdown', (event) ->
    document.location.reload !0
    $(this).html('Odeslání bude zítra!').parent().addClass 'disabled'
    return
  )
  return

renderTerminationClock = (element, date) ->
  $(element).countdown(date, (event) ->
    timeStr = event.offset.totalDays + ' days ' + event.strftime(event.offset.hours + ':%M:%S')
    $(this).html timeStr
    return
  ).on('finish.countdown', (event) ->
    document.location.reload !0
    $(this).html('Contract closed!').parent().addClass 'disabled'
    return
  )
  return

$(document).on 'turbolinks:load', ->
  $.each $('.clock-termination'), (index, element) ->
    date = $(element).data('date')
    renderTerminationClock(element, date) if date != ''
    return
  today = changeTimezone(new Date, 'Europe/Prague')
  [em,ed] = getEaster(today.getFullYear())
  dateFriday = new Date(today.getFullYear(), em - 1, ed)
  dateFriday.setDate dateFriday.getDate() - 2
  svatky.push dateFriday.getDate() + '-' + (dateFriday.getMonth() + 1)
  dateMonday = new Date(today.getFullYear(), em - 1, ed)
  dateMonday.setDate dateMonday.getDate() + 1
  svatky.push dateMonday.getDate() + '-' + (dateMonday.getMonth() + 1)
  dateDelivery = addBusinessDays(today, if (changeTimezone(new Date, 'Europe/Prague')).getHours() < 14 then 0 else 1)
  nextDay = dateDelivery.getFullYear() + '/' + ('0' + (dateDelivery.getMonth() + 1)).slice(-2) + '/' + ('0' + dateDelivery.getDate()).slice(-2) + ' 14:00'
  renderClock $('#clock-cut-off'), nextDay
  return
